<ng-container *ngIf="widget.widgetConfig && widget.widgetConfig.matUiType ">
    <!-- text field  -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.textbox"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)"
        [style.margin-top]="widget.widgetConfig?.style['margin-top']" [class.selected-widget]="widget.open">

        <ng-container *ngIf='widget.widgetConfig.matUiType === "filled"'>
            <md-filled-text-field [label]="widget.widgetLabel" [required]="isRequired(widget.widgetConfig?.validations)"
                [placeholder]="widget.widgetConfig.placeholderText" [type]="widget.widgetConfig.type"
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-filled-text-field-input-text-color':widget.widgetConfig?.style?.color,'--md-filled-text-field-hover-input-text-color':widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']" class="text-field-custom">
            </md-filled-text-field>
        </ng-container>
        <ng-container *ngIf='widget.widgetConfig.matUiType === "outlined"'>
            <md-outlined-text-field [label]="widget.widgetLabel"
                [required]="isRequired(widget.widgetConfig?.validations)"
                [placeholder]="widget.widgetConfig.placeholderText" [type]="'text'"
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-outlined-text-field-input-text-color':widget.widgetConfig?.style?.color,'--md-outlined-text-field-hover-input-text-color':widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']" class="text-field-custom">
            </md-outlined-text-field>
        </ng-container>
    </div>

    <!-- drop down  -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.dropdown"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [ngStyle]="widget.widgetConfig?.style"
        [class.selected-widget]="widget.open">
        <ng-container *ngIf="widget.widgetConfig?.type == 'SingleSelect'">
            <ng-container *ngIf='widget.widgetConfig.matUiType === "filled"'>
                <md-filled-select [label]="widget.widgetLabel" [placeholder]="widget.widgetConfig.placeholderText"
                    [required]="isRequired(widget.widgetConfig?.validations)"
                    [ngStyle]="{'--md-filled-select-text-field-label-text-font': selectedBodyFamily}" class="w-100">
                        <md-select-option class="text-multi-line"
                            *ngFor="let item of []">{{item}}</md-select-option>
                </md-filled-select>
            </ng-container>

            <ng-container *ngIf='widget.widgetConfig.matUiType === "outlined"'>
                <md-outlined-select [label]="widget.widgetLabel" [placeholder]="widget.widgetConfig.placeholderText"
                    [required]="isRequired(widget.widgetConfig?.validations)"
                    [ngStyle]="{'--md-outlined-select-text-field-label-text-font': selectedBodyFamily}" class="w-100">
                    <md-select-option 
                    *ngFor="let item of []">{{item}}</md-select-option>
                </md-outlined-select>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="widget.widgetConfig?.type != 'SingleSelect'">
            <md-outlined-select [label]="widget.widgetLabel" [placeholder]="widget.widgetConfig.placeholderText"
                [ngStyle]="{'font-family': selectedHeadFontFamily}" class="w-100" multiple>
                <span class="error-message" *ngIf="isRequired(widget.widgetConfig?.validations)">*</span>
                <ng-container *ngIf="!widget.widgetDataSource.datasourceType">
                    <md-select-option class="mb-form-search-select" [style.font-family]="selectedBodyFamily"
                        [placeholder]="widget.widgetConfig.placeholderText"></md-select-option>
                </ng-container>
                <md-select-option 
                    *ngFor="let item of []">{{item}}</md-select-option>
            </md-outlined-select>
        </ng-container>
    </div>

    <!-- searchable dropdown -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.searchableDropdown"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [class.selected-widget]="widget.open">

    </div>

    <!-- radio button  -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.radio"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [ngStyle]="widget.widgetConfig?.style"
        [class.selected-widget]="widget.open">
        <label class="mb-form-label ellipsis-input" [style.font-family]="selectedHeadFontFamily"
            [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}<span
                *ngIf="isRequired(widget.widgetConfig?.validations)">*</span></label>

        <div role="radiogroup" aria-labelledby="group-title" class="d-flex flex-column gap-1 mat-radio-check-button">
            <div *ngFor="let value of widget.widgetDataSource?.datasource" class="d-flex align-items-center">
                <md-radio id="first-radio" name="group" value="1" aria-label="First" class="m-2"></md-radio>
                <label for="first-radio" class="rc-label ellipsis-input"
                    [style.font-family]="selectedBodyFamily">{{value.label}}</label>
            </div>
        </div>
    </div>


    <!-- checkbox -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.singleselectcheckbox"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [ngStyle]="widget.widgetConfig?.style"
        [class.selected-widget]="widget.open">
        <label [style.color]="widget.widgetConfig?.style?.color"
            [style.font-size]="widget.widgetConfig?.style['font-size']" [style.font-family]="selectedBodyFamily"
            class="d-flex align-items-center mat-radio-check-button">
            <md-checkbox touch-target="wrapper" class="m-2"></md-checkbox>
            <div class="rc-label ellipsis-input">
                {{widget.widgetLabel}}<span *ngIf="isRequired(widget.widgetConfig?.validations)">*</span>
            </div>
        </label>
    </div>


    <!-- button  -->
    <div class="mb-form-group style-none" *ngIf="widget.widgetType == widgetTypes.button"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)"
        [style.margin-top]="widget.widgetConfig?.style['margin-top']" [class.selected-widget]="widget.open"
        [class.selected-widget]="widget.open">
        <ng-container *ngIf="widget.widgetConfig.customStyleApplied">
            <ng-container *ngIf='widget.widgetConfig.matUiType === "filled"'>
                <md-filled-button class="md-button" [style.font-family]="selectedBodyFamily" [ngStyle]="{'--md-filled-button-container-color': widget.widgetConfig?.style?.backgroundColor,'--md-filled-button-label-text-color': widget.widgetConfig?.style?.color,
                '--md-filled-button-hover-label-text-color':widget.widgetConfig?.style?.color}"
                    [style.font-style]="widget.widgetConfig?.style['font-style']"
                    [style.font-size]="widget.widgetConfig?.style['font-size']"
                    [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                    [style.width]="widget.widgetConfig?.style['width']"
                    [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}</md-filled-button>
            </ng-container>
            <!-- <ng-container *ngIf='widget.widgetConfig.matUiType === "elevated"'>
            <md-elevated-button [style.font-family]="selectedBodyFamily"
                [ngStyle]="{'--md-elevated-button-container-color': widget.widgetConfig?.style?.backgroundColor,'--md-elevated-button-label-text-color': widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}</md-elevated-button>
        </ng-container> -->
            <ng-container *ngIf='widget.widgetConfig.matUiType === "outlined"'>
                <md-outlined-button class="md-button" [style.font-family]="selectedBodyFamily"
                    [ngStyle]="{'--md-outlined-button-outline-color': widget.widgetConfig?.style?.backgroundColor,'--md-outlined-button-label-text-color': widget.widgetConfig?.style?.color,'--md-outlined-button-hover-label-text-color':widget.widgetConfig?.style?.color}"
                    [style.font-style]="widget.widgetConfig?.style['font-style']"
                    [style.font-size]="widget.widgetConfig?.style['font-size']"
                    [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                    [style.width]="widget.widgetConfig?.style['width']"
                    [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}
                </md-outlined-button>
            </ng-container>
            <!-- <ng-container *ngIf='widget.widgetConfig.matUiType === "tonal"'>
            <md-filled-tonal-button [style.font-family]="selectedBodyFamily"
                [ngStyle]="{'--md-filled-tonal-button-container-color': widget.widgetConfig?.style?.backgroundColor,'--md-filled-tonal-button-label-text-font': widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}</md-filled-tonal-button>
        </ng-container>
        <ng-container *ngIf='widget.widgetConfig.matUiType === "text"'>
            <md-text-button [style.font-family]="selectedBodyFamily"
                [ngStyle]="{'--md-text-button-container-color': widget.widgetConfig?.style?.backgroundColor}"
                [ngStyle]="{'--md-text-button-label-text-color': widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}</md-text-button>
        </ng-container> -->
        </ng-container>
        <ng-container *ngIf="!widget.widgetConfig.customStyleApplied">
            <ng-container *ngIf='widget.widgetConfig.matUiType === "filled"'>
                <md-filled-button class="md-button" [style.font-family]="selectedBodyFamily"
                    [style.font-style]="widget.widgetConfig?.style['font-style']"
                    [style.font-size]="widget.widgetConfig?.style['font-size']"
                    [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                    [style.width]="widget.widgetConfig?.style['width']"
                    [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}</md-filled-button>
            </ng-container>
            <ng-container *ngIf='widget.widgetConfig.matUiType === "outlined"'>
                <md-outlined-button class="md-button" [style.font-family]="selectedBodyFamily"
                    [style.font-style]="widget.widgetConfig?.style['font-style']"
                    [style.font-size]="widget.widgetConfig?.style['font-size']"
                    [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                    [style.width]="widget.widgetConfig?.style['width']"
                    [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}
                </md-outlined-button>
            </ng-container>
        </ng-container>
        @if(widget.widgetConfig?.actions.length > 0){
            <ng-container  *ngTemplateOutlet="actionsTemplate; context: { $implicit: widget.widgetConfig?.actions }" ></ng-container>
        <!-- </div>     -->
        }
    </div>


    <!-- footer button in progress  -->
    <div *ngIf="widget.widgetType == 'FootButton'" (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)"
        [ngStyle]="widget.widgetConfig?.style">
        <button mat-icon-button [type]="widget.type || 'button'" [ngStyle]="widget.widgetConfig?.style"
            [style.font-family]="selectedHeadFontFamily"><mat-icon>arrow_back</mat-icon>{{widget.widgetLabel}}</button>
    </div>

    <!-- file picker  -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.filePicker"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [ngStyle]="widget.widgetConfig?.style"
        [style.margin-top]="widget.widgetConfig?.style['margin-top']" [class.selected-widget]="widget.open">
        <ng-container *ngIf='widget.widgetConfig.matUiType === "filled"'>
            <md-filled-text-field [label]="widget.widgetLabel" [required]="isRequired(widget.widgetConfig?.validations)"
                [placeholder]="widget.widgetConfig.placeholderText"
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-filled-text-field-input-text-color':widget.widgetConfig?.style?.color,'--md-filled-text-field-hover-input-text-color':widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']" class="text-field-custom">
                <md-icon slot="trailing-icon"><mat-icon>attach_file_add</mat-icon></md-icon>
            </md-filled-text-field>
        </ng-container>
        <ng-container *ngIf='widget.widgetConfig.matUiType === "outlined"'>
            <md-outlined-text-field [label]="widget.widgetLabel"
                [required]="isRequired(widget.widgetConfig?.validations)"
                [placeholder]="widget.widgetConfig.placeholderText"
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-outlined-text-field-input-text-color':widget.widgetConfig?.style?.color,'--md-outlined-text-field-hover-input-text-color':widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']" class="text-field-custom">
                <md-icon slot="trailing-icon"><mat-icon>attach_file_add</mat-icon> </md-icon>
            </md-outlined-text-field>
        </ng-container>
    </div>

    <!-- image picker  -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.image"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [ngStyle]="widget.widgetConfig?.style"
        [style.margin-top]="widget.widgetConfig?.style['margin-top']" [class.selected-widget]="widget.open">
        <ng-container *ngIf='widget.widgetConfig.matUiType === "filled"'>
            <md-filled-text-field [label]="widget.widgetLabel" [required]="isRequired(widget.widgetConfig?.validations)"
                [placeholder]="widget.widgetConfig.placeholderText"
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-filled-text-field-input-text-color':widget.widgetConfig?.style?.color,'--md-filled-text-field-hover-input-text-color':widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']" class="text-field-custom">
                <md-icon slot="trailing-icon"><mat-icon>add_photo_alternate</mat-icon></md-icon>
            </md-filled-text-field>
        </ng-container>
        <ng-container *ngIf='widget.widgetConfig.matUiType === "outlined"'>
            <md-outlined-text-field [label]="widget.widgetLabel"
                [required]="isRequired(widget.widgetConfig?.validations)"
                [placeholder]="widget.widgetConfig.placeholderText"
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-outlined-text-field-input-text-color':widget.widgetConfig?.style?.color,'--md-outlined-text-field-hover-input-text-color':widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']" class="text-field-custom">
                <md-icon slot="trailing-icon"><mat-icon>add_photo_alternate</mat-icon></md-icon>
            </md-outlined-text-field>
        </ng-container>
    </div>

    <!-- date picker  -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.date"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [class.selected-widget]="widget.open"
        [style.margin-top]="widget.widgetConfig?.style['margin-top']">
        <ng-container *ngIf='widget.widgetConfig.matUiType === "filled"'>
            <md-filled-text-field
                [label]="widget.widgetId == widgetId ? (widgetLabel !== '' ? widgetLabel : widget.widgetLabel) : widget.widgetLabel"
                [required]="isRequired(widget.widgetConfig?.validations)"
                [placeholder]=" widget.widgetId == widgetId ? placeholder != '' ? placeholder : widget.widgetConfig.placeholderText : widget.widgetConfig.placeholderText"
                [style.color]="widget.widgetConfig?.style?.color"
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-filled-text-field-input-text-color':widget.widgetConfig?.style?.color,'--md-filled-text-field-hover-input-text-color':widget.widgetConfig?.style?.color}"
                class="text-field-custom">
                <md-icon slot="trailing-icon"><mat-icon>calendar_month</mat-icon></md-icon>
            </md-filled-text-field>
        </ng-container>
        <ng-container *ngIf='widget.widgetConfig.matUiType === "outlined"'>
            <md-outlined-text-field [label]="widget.widgetLabel"
                [required]="isRequired(widget.widgetConfig?.validations)"
                [placeholder]="widget.widgetConfig.placeholderText"
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-outlined-text-field-input-text-color':widget.widgetConfig?.style?.color,'--md-outlined-text-field-hover-input-text-color':widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']" class="text-field-custom">
                <md-icon slot="trailing-icon"><mat-icon>calendar_month</mat-icon></md-icon>
            </md-outlined-text-field>
        </ng-container>
    </div>

    <!-- text  -->
    <ng-container *ngIf="widget.widgetType == widgetTypes.plainText">
        <div class="mb-form-group style-none" (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)"
            [style.margin-top]="widget.widgetConfig?.style['margin-top']" [class.selected-widget]="widget.open"
            *ngIf="widget.widgetConfig?.enable">
            <div class="mb-form-title-text" style="border:0; overflow:auto; word-wrap:break-word">
                <h2 [style.font-family]="selectedBodyFamily" [style.color]="widget.widgetConfig?.style?.color"
                    [style.font-style]="widget.widgetConfig?.style['font-style']"
                    [style.font-size]="widget.widgetConfig?.style['font-size']"
                    [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                    [style.text-decoration]="widget.widgetConfig?.style['text-decoration']"
                    [style.text-align]="widget.widgetConfig?.style['text-align']">{{widget.widgetLabel}}</h2>
            </div>
        </div>
    </ng-container>

    <!-- navgation heading in progress  -->
    <div *ngIf="widget.widgetType == widgetTypes.navText" [ngStyle]="widget.widgetConfig?.style"
        [class.selected-widget]="widget.open" [class.selected-widget]="widget.open">
        <h3 [style.font-family]="selectedHeadFontFamily">{{widget.widgetLabel}}</h3>
    </div>

    <!-- navgation button in progress  -->
    <div *ngIf="widget.widgetType == widgetTypes.navButton" class="d-flex justify-content-space-between"
        [ngStyle]="widget.widgetConfig?.style">
        <button mat-icon-button [type]="widget.type || 'button'"><mat-icon>{{widget?.widgetConfig?.image ||
                ''}}</mat-icon></button>
    </div>


    <!-- image uploader -->
    <div class="mb-form-group style-none"
        *ngIf="widget.widgetType == widgetTypes.imageUploader && widget?.widgetConfig?.enable"
        [ngStyle]="page.pageType === 'SplashScreenPage' ? {'margin-top': '0px'} : widget?.widgetConfig?.style"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [class.selected-widget]="widget.open">
        <div [ngClass]="{'login-image':page.pageType === 'LoginPage'}"
            style="width: 100%; height: 100%; overflow: hidden;">
                <mat-spinner *ngIf="loading" [id]="widget.widgetId" [diameter]="20" class="spinner"></mat-spinner>
                <img [src]="getImageFile()" style="width: 100%; display: block;" loading="lazy" (load)="loading = false" (error)="loading = false" #imageRef />          
        </div>
    </div>


    <!-- faceId -->
    <div class="mb-form-group style-none" *ngIf="widget.widgetType == widgetTypes.faceId"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [ngStyle]="widget.widgetConfig?.style"
        [class.selected-widget]="widget.open">
        <div class="image">
            <img src="../assets/images/face-id.svg" class="biometric" loading="lazy">
        </div>
    </div>

    <!-- fingerprint -->
    <ng-container *ngIf="widget.widgetType == widgetTypes.fingerPrint">
        <div class="mb-form-group style-none" *ngIf="widget.widgetConfig?.enable"
            (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [ngStyle]="widget.widgetConfig?.style"
            [class.selected-widget]="widget.open">
            <div class="image">
                <img src="../assets/images/biometric.svg" class="biometric"  loading="lazy">
            </div>
        </div>
    </ng-container>

    <!-- separator -->
    <div class="mb-form-group style-none " *ngIf="widget.widgetType == widgetTypes.separator"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [class.selected-widget]="widget.open"
        [style.margin-top]="widget.widgetConfig?.style['margin-top']">
        <md-divider
            [ngStyle]="{'--md-divider-thickness': widget.widgetConfig?.style['size'],'--md-divider-color':widget.widgetConfig?.style?.color}"></md-divider>
    </div>


    <div class="scanner mb-form-group" *ngIf="widget.widgetType == widgetTypes.scanner"
        [ngStyle]="widget.widgetConfig?.style" (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)"
        [style.margin-top]="widget.widgetConfig?.style['margin-top']" [class.selected-widget]="widget.open">

        <ng-container *ngIf='widget.widgetConfig.matUiType === "filled"'>
            <md-filled-text-field [label]="widget.widgetLabel" [required]="isRequired(widget.widgetConfig?.validations)"
                [placeholder]="widget.widgetConfig.placeholderText" [style.color]="widget.widgetConfig?.style?.color"
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-filled-text-field-input-text-color':widget.widgetConfig?.style?.color,'--md-filled-text-field-hover-input-text-color':widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']" class="text-field-custom">
                <md-icon slot="trailing-icon"><span class="mdi mdi-line-scan"></span></md-icon>
            </md-filled-text-field>
        </ng-container>
        <ng-container *ngIf='widget.widgetConfig.matUiType === "outlined"'>
            <md-outlined-text-field [label]="widget.widgetLabel"
                [required]="isRequired(widget.widgetConfig?.validations)"
                [placeholder]="widget.widgetConfig.placeholderText"
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-outlined-text-field-input-text-color':widget.widgetConfig?.style?.color,'--md-outlined-text-field-hover-input-text-color':widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']" class="text-field-custom">
                <md-icon slot="trailing-icon"><span class="mdi mdi-line-scan"></span></md-icon>

            </md-outlined-text-field>
        </ng-container>


    </div>

    <!-- address  -->
    <div class=" scanner mb-form-group" *ngIf="widget.widgetType == widgetTypes.address"
        [ngStyle]=" widget.widgetId == widgetId ? textColor != '' ? {'color' : textColor} : widget.widgetConfig?.style : widget.widgetConfig?.style"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)"
        [style.margin-top]="widget.widgetConfig?.style['margin-top']" [class.selected-widget]="widget.open">

        <ng-container *ngIf='widget.widgetConfig.matUiType === "filled"'>
            <md-filled-text-field
                [label]="widget.widgetId == widgetId ? (widgetLabel !== '' ? widgetLabel : widget.widgetLabel) : widget.widgetLabel"
                [required]="isRequired(widget.widgetConfig?.validations)"
                [placeholder]=" widget.widgetId == widgetId ? placeholder != '' ? placeholder : widget.widgetConfig.placeholderText : widget.widgetConfig.placeholderText"
                [style.color]="widget.widgetConfig?.style?.color"
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-filled-text-field-input-text-color':widget.widgetConfig?.style?.color,'--md-filled-text-field-hover-input-text-color':widget.widgetConfig?.style?.color}"
                class="text-field-custom">
                <md-icon slot="trailing-icon"> <mat-icon>location_on</mat-icon></md-icon>
            </md-filled-text-field>
        </ng-container>
        <ng-container *ngIf='widget.widgetConfig.matUiType === "outlined"'>
            <md-outlined-text-field [label]="widget.widgetLabel"
                [required]="isRequired(widget.widgetConfig?.validations)"
                [placeholder]="widget.widgetConfig.placeholderText"
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-outlined-text-field-input-text-color':widget.widgetConfig?.style?.color,'--md-outlined-text-field-hover-input-text-color':widget.widgetConfig?.style?.color}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.width]="widget.widgetConfig?.style['width']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']" class="text-field-custom">
                <md-icon slot="trailing-icon"><mat-icon>location_on</mat-icon></md-icon>
            </md-outlined-text-field>
        </ng-container>
    </div>

    <!-- geotag -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.geotag" [ngStyle]="widget.widgetConfig?.style"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)"
        [style.margin-top]="widget.widgetConfig?.style['margin-top']" [class.selected-widget]="widget.open">
        <div class="input-wrapper">
            <label class="mb-form-control ellipsis-input" [style.color]="widget.widgetConfig?.style?.color"
                [style.font-family]="selectedBodyFamily">{{widget.widgetLabel}} <span
                    *ngIf="isRequired(widget.widgetConfig?.validations)">*</span></label>
            <div class="image-container">
                <img src="../assets/images/geotag.png" alt="" class="img-fluid"  loading="lazy">
            </div>
        </div>
    </div>

    <!-- geofence -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.geofence" [ngStyle]="widget.widgetConfig?.style"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)"
        [style.margin-top]="widget.widgetConfig?.style['margin-top']" [class.selected-widget]="widget.open">
        <div class="input-wrapper">
            <label class="mb-form-control ellipsis-input" [style.color]="widget.widgetConfig?.style?.color"
                [style.font-family]="selectedBodyFamily">{{widget.widgetLabel}} <span
                    *ngIf="isRequired(widget.widgetConfig?.validations)">*</span></label>
            <div class="image-container">
                <img src="../assets/images/geotag.png" alt="" class="img-fluid"  loading="lazy">
            </div>
        </div>
    </div>

    <!-- chatbot -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.chatBot"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)"
        [style.margin-top]="widget.widgetConfig?.style['margin-top']" [class.selected-widget]="widget.open">
        <ng-container *ngIf="{
            textColor: widget.widgetConfig.customStyleApplied ? widget.widgetConfig?.additionalConfig?.textColor : themeTextColor,
            bgColor: widget.widgetConfig.customStyleApplied ? widget.widgetConfig?.additionalConfig?.bgColor : primaryColor,
            panelHeight: widget.widgetConfig?.additionalConfig?.panelHeight + 'px',
            footerTextColor: widget.widgetConfig?.additionalConfig?.footerTextColor,
            footerBorderColor: widget.widgetConfig?.additionalConfig?.footerBorderColor,
            footerButtonColor: widget.widgetConfig?.additionalConfig?.footerButtonColor
          } as styles">
            <div class="main-container"
                [ngStyle]="{'color': styles.textColor, 'background-color': styles.bgColor, 'height': styles.panelHeight}">
                <div class="main-content h-100">
                    <div class="chatbot-body" #chatBotBody>
                        <div class="left-chat">
                            <div class="left-user avatar fw-bold"
                                [ngClass]="widget.widgetConfig?.additionalConfig?.avatarShape" #chatBotImage>
                                <div class="logo">
                                    <img *ngIf="widget.widgetConfig.additionalConfig.userAvatar === 'profilePic'"
                                        [src]="getAvatar()" alt="logo"  loading="lazy">
                                    <ng-container
                                        *ngIf="widget.widgetConfig.additionalConfig.userAvatar !== 'profilePic'">
                                        VL
                                    </ng-container>
                                </div>
                            </div>
                            <div class="left-user-message " [style.backgroundColor]="onPrimaryColor" #charBotMessage>Hi
                                Joe,<br>
                                How May I assist you today</div>
                        </div>
                        <div class="chat-loding">
                            <div class="chat-loder-icon" [style.backgroundColor]="onPrimaryColor">
                                <mat-icon>more_horiz</mat-icon>
                            </div>
                        </div>
                        <div class="right-chat">
                            <div class="right-user-message" [style.backgroundColor]="onPrimaryColor" #userMessage>Hi
                                Jane. I'm in the field and need your help.</div>
                            <div class="right-user"><i class="mdi mdi-account"></i></div>
                        </div>
                    </div>
                    <div class="footer-message-input d-flex align-items-center gap-2"
                        [ngStyle]="{ 'color': styles?.footerTextColor, 'border-color': styles?.footerBorderColor}">
                        <button *ngIf="widget.widgetConfig?.additionalConfig?.showAttachmentsIcon"
                            [ngStyle]="{'background-color': styles?.footerButtonColor}" mat-raised-button
                            class="btn btn-sm custom-add-btn">
                            <mat-icon class="rotated-link-icon">link</mat-icon>
                        </button>
                        <button *ngIf="widget.widgetConfig?.additionalConfig?.showTextInput" mat-raised-button
                            [ngStyle]="{'background-color': styles?.footerButtonColor, 'color': styles?.footerTextColor}"
                            class="btn btn-sm custom-add-btn"><mat-icon>add_comment</mat-icon></button>
                        <div class="input-group input-group-boat-message">
                            <input *ngIf="widget.widgetConfig?.additionalConfig?.showTextInput" type="text" matInput
                                placeholder="Ask a question..." class="form-control">
                            <span mat-icon-button type="button" class="input-group-text g-2">
                                <mat-icon *ngIf="widget.widgetConfig?.additionalConfig?.showSpeechIcon"
                                    [ngStyle]="{'background-color': styles?.footerButtonColor, 'color': styles?.footerTextColor}">mic</mat-icon>
                                <mat-icon *ngIf="widget.widgetConfig?.additionalConfig?.showSendIcon"
                                    [ngStyle]="{'background-color': styles?.footerButtonColor, 'color': styles?.footerTextColor}">send</mat-icon>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
    <!-- dataList -->
    <div class="mb-form-group" *ngIf="widget.widgetType == widgetTypes.datalist" [ngStyle]="widget.widgetConfig?.style"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [class.selected-widget]="widget.open">
        <div class="d-flex justify-content-between option-item  align-items-center"
            *ngIf="widget.widgetConfig?.additionalConfig as additionalConfig">
        
            <md-outlined-text-field *ngIf="additionalConfig?.search" [label]="'Search'" class="w-50  curved-field "
                [ngStyle]="{'--md-filled-text-field-label-text-font': selectedBodyFamily,'--md-outlined-text-field-input-text-color':themeTextColor,'--md-outlined-text-field-hover-input-text-color':themeTextColor,'--md-outlined-text-field-container-shape': '28px'}"
                [style.font-style]="widget.widgetConfig?.style['font-style']"
                [style.font-size]="widget.widgetConfig?.style['font-size']"
                [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">
                <md-icon slot="leading-icon"><span class="mdi mdi-magnify"></span></md-icon>
                <md-icon slot="trailing-icon"><span class="mdi mdi-close"></span></md-icon>
            </md-outlined-text-field>
            <!-- displayed by default  -->
            <button mat-icon-button [ngStyle]="{'color': primaryColor}" *ngIf="additionalConfig?.sort">
                <mat-icon>sort</mat-icon>
            </button>
            <button mat-icon-button [ngStyle]="{'color': primaryColor}" *ngIf="additionalConfig?.filter">
                <mat-icon>filter_list</mat-icon>
            </button>
            <button mat-icon-button [ngStyle]="{'color': primaryColor}" *ngIf="additionalConfig?.download">
                <mat-icon>download_2</mat-icon>
            </button>
            <button mat-icon-button [ngStyle]="{'color': primaryColor}" *ngIf="additionalConfig?.edit">
                <mat-icon>edit</mat-icon>
            </button>
        </div>
        <mat-card [ngStyle]="widget.widgetConfig?.style" [style.font-family]="selectedBodyFamily">
            <mat-card-content>
                <div class="d-flex justify-content-between gap-3">
                    <div class="flex-fill mb-text-value w-50">
                        <span class="text-ellipsis text-word-break"
                            *ngFor="let item of widget.widgetConfig?.dataListWidgetConfig?.lhsItems">{{item.widgetLabel}}</span>
                    </div>

                    <div class="mb-text-value text-right w-50">
                        <span class="text-ellipsis text-word-break"
                            *ngFor="let item of widget.widgetConfig?.dataListWidgetConfig?.rhsItems">{{item.widgetLabel}}</span>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- thermal printer  -->
    <div class="mb-form-group style-none" *ngIf="widget.widgetType == widgetTypes.printer"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)"
        [style.margin-top]="widget.widgetConfig?.style['margin-top']" [class.selected-widget]="widget.open"
        [class.selected-widget]="widget.open">
        <ng-container *ngIf="widget.widgetConfig.customStyleApplied">
            <ng-container *ngIf='widget.widgetConfig.matUiType === "filled"'>
                <md-filled-button class="md-button" [style.font-family]="selectedBodyFamily" [ngStyle]="{'--md-filled-button-container-color': widget.widgetConfig?.style?.backgroundColor,'--md-filled-button-label-text-color': widget.widgetConfig?.style?.color,
                '--md-filled-button-hover-label-text-color':widget.widgetConfig?.style?.color}"
                    [style.font-style]="widget.widgetConfig?.style['font-style']"
                    [style.font-size]="widget.widgetConfig?.style['font-size']"
                    [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                    [style.width]="widget.widgetConfig?.style['width']"
                    [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}</md-filled-button>
            </ng-container>
            <ng-container *ngIf='widget.widgetConfig.matUiType === "outlined"'>
                <md-outlined-button class="md-button" [style.font-family]="selectedBodyFamily"
                    [ngStyle]="{'--md-outlined-button-outline-color': widget.widgetConfig?.style?.backgroundColor,'--md-outlined-button-label-text-color': widget.widgetConfig?.style?.color,'--md-outlined-button-hover-label-text-color':widget.widgetConfig?.style?.color}"
                    [style.font-style]="widget.widgetConfig?.style['font-style']"
                    [style.font-size]="widget.widgetConfig?.style['font-size']"
                    [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                    [style.width]="widget.widgetConfig?.style['width']"
                    [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}
                </md-outlined-button>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!widget.widgetConfig.customStyleApplied">
            <ng-container *ngIf='widget.widgetConfig.matUiType === "filled"'>
                <md-filled-button class="md-button" [style.font-family]="selectedBodyFamily"
                    [style.font-style]="widget.widgetConfig?.style['font-style']"
                    [style.font-size]="widget.widgetConfig?.style['font-size']"
                    [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                    [style.width]="widget.widgetConfig?.style['width']"
                    [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}</md-filled-button>
            </ng-container>
            <ng-container *ngIf='widget.widgetConfig.matUiType === "outlined"'>
                <md-outlined-button class="md-button" [style.font-family]="selectedBodyFamily"
                    [style.font-style]="widget.widgetConfig?.style['font-style']"
                    [style.font-size]="widget.widgetConfig?.style['font-size']"
                    [style.font-weight]="widget.widgetConfig?.style['font-weight']"
                    [style.width]="widget.widgetConfig?.style['width']"
                    [style.text-decoration]="widget.widgetConfig?.style['text-decoration']">{{widget.widgetLabel}}
                </md-outlined-button>
            </ng-container>
        </ng-container>
    </div>

    <div *ngIf="displayWidgetCharts.includes(widget.widgetType)" class="chart-container card card-body m-3"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [class.selected-widget]="widget.open">
        <vl-highcharts-renderer class="d-block" [widgetType]="widget.widgetType" [height]="350"
            [widgetConfig]="widget.widgetConfig" [widgetData]="widget"></vl-highcharts-renderer>
    </div>

    <div *ngIf="widget.widgetType === widgetTypes.chatView" class="m-3"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [class.selected-widget]="widget.open">
        <mat-card>
            <mat-card-header>
                <div mat-card-avatar class="avatar fw-bold" *ngIf="widget.widgetConfig.additionalConfig.isLogo == 2">
                    {{widget.widgetLabel.slice(0,2) | titlecase}}
                </div>
                <div mat-card-avatar class="avatar " *ngIf="widget.widgetConfig.additionalConfig.isLogo == 1">
                    <div class="logo"><img [src]="imageUploaderDefault" alt="logo"  loading="lazy" /></div>
                </div>
                <mat-card-title>{{widget.widgetLabel}}</mat-card-title>
                <mat-card-subtitle>{{currentDate | date}}</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content>
                <p></p>
            </mat-card-content>
            <mat-card-actions class="d-flex justify-content-end">
                <mat-icon>chat</mat-icon>
            </mat-card-actions>
        </mat-card>
    </div>

    <div *ngIf="widget.widgetType === widgetTypes.dataBoard" [ngStyle]="widget.widgetConfig?.style"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" class="px-3">
        <mat-card [ngStyle]="widget.widgetConfig?.style" [style.font-family]="selectedBodyFamily"
            [class.selected-widget]="widget.open">
            <mat-card-content>
                <lib-data-boardwidget [widget]="widget"></lib-data-boardwidget>
            </mat-card-content>
        </mat-card>
    </div>

    <!-- overview Tracker -->
    <mat-card *ngIf="widget.widgetType === widgetTypes.overviewTracker" [ngStyle]="widget.widgetConfig?.style"
        (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" class="mx-3 w-auto status-tracker"
        [class.selected-widget]="widget.open">
        <ul [class.selected-widget]="widget.open">
            <li class="header">
                <h5 class="title">{{  widget.widgetLabel ?? '' | titlecase}}
                    <mat-icon *ngIf="widget.widgetConfig?.overviewTrackerConfig?.info"
                        [matTooltip]="widget.widgetConfig?.overviewTrackerConfig?.infoDescription">info_outline</mat-icon>
                </h5>
                <div *ngIf="widget.widgetConfig?.overviewTrackerConfig?.legend" class="status-items">
                    @for(status of widget.widgetConfig?.overviewTrackerConfig?.statusesColorCode;track status){
                    <span class="item"> <span class="color-box " [style.backgroundColor]="status.bgColor"
                            [style.color]="status.textColor"></span> {{ status.status ?? '' | titlecase}}</span>
                    }
                </div>
            </li>

            @for (item of widget.widgetConfig?.apiResponce ?? []; track $index; ) {
            <li class="list-of-tracker-item"[ngStyle]="{'--countSize': widget.widgetConfig?.additionalConfig?.serialNumber ? '2rem' : '0'}">
                <span class="count" *ngIf="widget.widgetConfig?.additionalConfig?.serialNumber" >{{$index + 1}}</span>
                <div class="content">
                    <h5 class="title">{{item[widget.widgetConfig?.overviewTrackerConfig?.statusLabel] ?? item.name }}</h5>
                <div class="list-status-box-items">
                    @for(statusType of widget.widgetConfig?.overviewTrackerConfig?.statuses; track statusType){
                    <span
                        [style.backgroundColor]="widget.widgetConfig?.additionalConfig?.statusesColorObj[statusType].bgColor"
                        [style.color]="widget.widgetConfig?.additionalConfig?.statusesColorObj[statusType].textColor"
                        class="box-item">
                        {{ item[statusType] ?? 0 }}
                    </span>
                    }
                </div>
                </div>
            </li>
            }
        </ul>
    </mat-card>

    <!-- filter  -->
    @if(widget.widgetType === widgetTypes.filter){
        <mat-card [ngStyle]="widget.widgetConfig?.style" class="w-auto m-3 filter-fields cursor-pointer" (click)="onClick($event,widget.widgetId,sectionIndex,widgetIndex,widget)" [class.selected-widget]="widget.open">
            @if(widget.widgetConfig?.filters){
                @for(filter of widget.widgetConfig?.filters;track filter){
                    @if(filter.filterType == 'dropdown'){
                        <mat-form-field appearance="outline" class="mat-no-hint my-1">
                            <mat-label>{{filter.label}}</mat-label>
                            <mat-select>
                            @for (value of filter.manualValues ?? []; track value) {
                                <mat-option [value]="value">{{value}}</mat-option>
                            }
                            </mat-select>
                        </mat-form-field>
                    }@else{
                        <mat-form-field appearance="outline" class="mat-no-hint my-1">
                            <mat-date-range-input [rangePicker]="picker" >
                            <input matStartDate placeholder="Start date">
                            <input matEndDate placeholder="End date">
                            </mat-date-range-input>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker></mat-date-range-picker>
                        </mat-form-field>
                    }
                }
            }@else {
                <div class="m-1 p-1">{{"Filter"}}</div>
            }
        </mat-card>
    }

</ng-container>

<ng-template #actionsTemplate let-actions="$implicit">
   @for(action of actions;track action){
    @if(action['action_type'] === widgetClickActions.lineItem){
        <div class="overflow-scroll mt-2" > 
         <ng-container [ngSwitch]="renderTemplateview">
            <ng-container *ngSwitchCase="'table'">

               <!-- Table Layout -->
                  <table  class=" w-100 ">
                    <thead [style.backgroundColor]="primaryContainerColor">
                      <tr >
                        <th *ngFor="let item of initalLineAction?.lhsItems || []" class="px-2">
                          
                          <span class="d-flex justify-content-center" >{{ lineItemwidgetsMap[item.widgetId]?.widgetLabel ?? item.widgetLabel  | titlecase}}</span>
                        </th>
                        <th *ngFor="let item of initalLineAction?.rhsItems || []" class="px-2">
                            <span class="d-flex justify-content-center" >{{ lineItemwidgetsMap[item.widgetId]?.widgetLabel ?? item.widgetLabel  | titlecase}}</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody *ngIf="initalLineAction?.lhsItems.length > 0 || initalLineAction?.rhsItems.length > 0">
                        <tr *ngFor="let item of [1,2]">
                            <th *ngFor="let item of initalLineAction?.lhsItems || []" >
                               <span class="d-flex justify-content-center" [style.color]="themeTextColor">-</span>
                            </th>
                            <th *ngFor="let item of initalLineAction?.rhsItems || []" >
                                <span class="d-flex justify-content-center" [style.color]="themeTextColor">-</span>
                            </th>
                          </tr>
                    </tbody>
                    <!-- Add table body logic here if needed -->
                  </table>
            </ng-container>
          
            <ng-container *ngSwitchCase="'card'">
              <!-- Card Layout -->
              <mat-card [style.font-family]="selectedBodyFamily">
                <mat-card-content>
                  <div class="d-flex justify-content-between gap-3">
                    <div class="flex-fill mb-text-value w-50">
                      <span class="text-ellipsis text-word-break" *ngFor="let item of initalLineAction?.lhsItems || []">
                       {{ lineItemwidgetsMap[item.widgetId]?.widgetLabel ?? item.widgetLabel  | titlecase}}
                      </span>
                    </div>
                    <div class="mb-text-value text-right w-50">
                      <span class="text-ellipsis text-word-break" *ngFor="let item of initalLineAction?.rhsItems || []">
                       {{ lineItemwidgetsMap[item.widgetId]?.widgetLabel ?? item.widgetLabel | titlecase }}
                      </span>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
            </ng-container>
          
            <ng-container *ngSwitchDefault>
              <!-- Fallback Layout -->
              <div class="d-flex">
                @if(showPagesSpinner){
                    <mat-spinner class="spinner-table justify-content-center" [diameter]="25" [id]="'filter-table-spinner'"></mat-spinner>
                }
                @else {
                    <ng-container *ngFor="let widget of relativeWidgets; let i = index;">
                      <lib-widget-filter
                        class="w-100"
                        [ngStyle]="{ 'min-width': '240px', 'pointer-events': 'none' }"
                        [widget]="widget"
                        [sectionIndex]="1"
                        [widgetIndex]="i"
                        [page]="page">
                      </lib-widget-filter>
                    </ng-container>
                }
              </div>
            </ng-container>
          </ng-container>
          </div>
          
        }
    }

</ng-template>